import { Button } from '@/components/atom/Button';
import { Image } from '@/components/atom/Image';
import { AiOutlineCheck, AiOutlineClose } from 'react-icons/ai';
import { ExchangeOrder } from '@/constants/types';
import { useMemo } from 'react';
import { getOrderInfo } from '@/components/exchange/orders/Order';
import { TokenUnit } from '@/components/atom/TokenUnit';
import { useRecoilValue } from 'recoil';
import { exchangeDataAtom, marketOrdersAtom } from '@/state/app';

export interface MarketOrderProps {
    orderId: number;
    fulfillOrder: (order: ExchangeOrder) => void;
}

export const MarketOrder = ({ orderId, fulfillOrder }: MarketOrderProps) => {
    const exchangeData = useRecoilValue(exchangeDataAtom);
    const { orders } = useRecoilValue(marketOrdersAtom);
    const order = orders[orderId];
    const info = useMemo(() => getOrderInfo({ order, exchangeData }), [exchangeData.update, order]);
    return !info ? null : (
        <div className="relative grid items-center w-full grid-cols-7 py-1 mb-1 text-center rounded-lg bg-grey-50/50 text-grey-10 t__subtitle--s2">
            <div className="absolute top-0 left-0 flex w-3 h-3 pl-[1px] leaf bg-main-50">
                <Image
                    asset={order.startTime == 0 ? info.primary!.networkAsset : info!.token!.networkAsset}
                    height={10}
                    width={10}
                />
            </div>
            <div className="flex justify-center space-x-2">
                <Image asset={info.icon} isIcon height={20} width={20} />
                <span>{info.tokenName}</span>
            </div>
            <TokenUnit value={order.startTime == 0 ? order.amount : order.amountValue} />
            <div className="flex justify-center">
                {order.allowPartial ? (
                    <div className="text-teal-60">
                        <AiOutlineCheck />
                    </div>
                ) : (
                    <div className="text-grey-30">
                        <AiOutlineClose />
                    </div>
                )}
            </div>
            <span>{Math.round(order.fee * 100 * 100) / 100}%</span>
            {/*<span className="whitespace-nowrap">10%</span>*/}
            {/*<span className=" whitespace-nowrap">3 days</span>*/}
            <Button variant="teal-primary" size="alt-block" onClick={() => fulfillOrder(order)}>
                Fulfill
            </Button>
        </div>
    );
};
